var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfSectionProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#68686A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 2.24c4.275 0 7.758 3.483 7.758 7.756S14.275 17.751 10 17.751 2.242 14.27 2.242 9.996 5.725 2.241 10 2.241ZM10 .5C4.751.5.5 4.75.5 9.996c0 5.247 4.251 9.496 9.5 9.496s9.5-4.25 9.5-9.496C19.5 4.749 15.249.5 10 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6.292a2.598 2.598 0 0 1 2.597 2.596 2.598 2.598 0 0 1-5.193 0A2.598 2.598 0 0 1 10 6.292Zm0-1.74a4.334 4.334 0 0 0-4.338 4.336A4.334 4.334 0 0 0 10 13.224a4.334 4.334 0 0 0 4.339-4.336A4.334 4.334 0 0 0 10 4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.978 16.382C4.72 18.289 7.213 19.5 10 19.5a9.442 9.442 0 0 0 7.022-3.118A7.702 7.702 0 0 0 10 11.848a7.702 7.702 0 0 0-7.022 4.534Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfSectionProfile);
export default __webpack_public_path__ + "static/media/pdfSectionProfile.74f1317edc2d9362ef6aed2ea84a8556.svg";
export { ForwardRef as ReactComponent };